import Modal from "react-modal";
import { Button } from "../components";

const WarningPopup = (props) => {
    const customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            maxHeight: "100vh",
            overflowY: "auto",
            color: "red",
        },
        overlay: {
            zIndex: "999999",
        }
    };

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onCancel}
            style={customStyles}
            contentLabel="Survey selector"
        >
            <div>
                <h2 className={"warning-text"}>{props.message}</h2>
                <div
                    style={{ justifyContent: "space-evenly", display: "flex" }}
                >
                    <Button label="OK" onClick={props.onConfirm} />
                </div>
            </div>
        </Modal>
    );
};

export default WarningPopup;
